import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-123">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-124">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-125" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden z-10" data-id="element-126">
            {/* Header */}
            <div className="sticky top-0 bg-white border-b border-sage/10 px-6 py-4 flex items-center justify-between z-10" data-id="element-127">
              <h3 className="text-xl font-bold text-charcoal font-playfair" data-id="element-128">
                {title}
              </h3>
              <button onClick={onClose} className="w-9 h-9 rounded-full bg-cream flex items-center justify-center hover:bg-terracotta/10 transition-colors" aria-label="Cerrar" data-id="element-129">
                <X className="w-5 h-5 text-charcoal" data-id="element-130" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-warmgray leading-relaxed text-sm space-y-4" data-id="element-131">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}